import { API_URL } from '../constants/api_url';
import { isFetching } from '../stores/isFetching';

const ENDPOINT = `${API_URL}/ova/cancellation`;

const HEADERS = {
  'Content-Type': 'application/json',
};

function buildBody(payload) {
  return JSON.stringify({
    regionId: payload.region,
    orderId: payload.orderNumber,
    contractId: payload.contractNumber,
    deviceNumber: payload.meterNumber,
    firstname: payload.firstname,
    lastname: payload.lastname,
    email: payload.email,
    address: {
      street: payload.street,
      houseNumber: payload.houseNumber,
      zipcode: payload.zipcode,
      city: payload.city,
    },
  });
}

export async function postWithdrawal(payload) {
  isFetching.set(true);

  try {
    const res = await fetch(ENDPOINT, {
      method: 'POST',
      body: buildBody(payload),
      headers: HEADERS,
    });

    if (!res.ok) {
      throw new Error(res.statusText);
    }
    
  } finally {
    isFetching.set(false);
  }
}
